export const generateModelIdFromName = (name: string): string =>
  name
    .toLowerCase()
    .trim()
    .replace(/\s+/g, '_')
    .replace(/[^a-z0-9_]+/g, '')
    .replace(/_{2,}/g, '_')
    .replace(/(_$|^_)/g, '')
    .toUpperCase();

export const isDigitsOnly = (value: string): boolean => /^[0-9]+$/.test(value);
